import { useEffect, useState } from "react";
import useVehicleEnquiry from "../hooks/useVehicleEnquiry";
import useWebData from "../hooks/useWebData";
import usePleaseWait from "../hooks/usePleaseWait";
import PhoneNumberInput from "./PhoneNumberInput";
import { post_VehicleIsNotAvailable } from "../services/vehicleClass";
import useReservation from "../hooks/useReservationData";
import { tenantId } from "../config/api";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const VehicleEnquiryPopup = () => {     
    const { webData }: any = useWebData();
    const {      
        branchId,
        pickupLocationId,
        returnLocationId,
        pickupDate,
        pickupTime,
        returnDate,
        returnTime,

    }: any = useReservation();
    const { setPleasWaitPopup }: any = usePleaseWait();
    const { open, setOpen, vehicleClassId }: any = useVehicleEnquiry();
    const [email, setEmail] = useState<string>("");
    const [phoneNumber, setPhoneNumber] = useState<string>("");
    const [error, setError] = useState('');


    useEffect(() => {
        if (open) {
            document.body.classList.add("overflow-hidden");
            setEmail("");
            setPhoneNumber("");
            setError("");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => document.body.classList.remove("overflow-hidden");
    }, [open]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setEmail(value);

        // Clear error as user types
        if (error) setError('');
    };

    const validateEmail = () => {
        if (email?.trim() !== "" && !emailRegex.test(email)) {
            setError('Please enter a valid email address');
        } else {
            setError('');
        }
    };

    const closeModal = () => setOpen(false);


    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!error) {
            setOpen(false)
            setPleasWaitPopup(true);           
            post_VehicleIsNotAvailable({
                branchId,
                pickupLocationId,
                returnLocationId,
                pickupDate: pickupDate + 'T' + pickupTime,
                returnDate: returnDate + 'T' + returnTime,
                vehicleClassId,
                customerEmail: email,
                customerPhoneNumber: phoneNumber
            }, tenantId)
                .then((_) => {
                    setPleasWaitPopup(false);
                })
                .catch((error) => {
                    setPleasWaitPopup(false);
                    console.error(error)
                })
        }

    }
    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="w-full max-w-xl mx-4 bg-white p-6 rounded-xl shadow-lg">
                {/* Close Icon */}
                <div className="flex justify-end">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320.591 320.591"
                        className="w-4 h-4 cursor-pointer fill-gray-600"
                        onClick={closeModal}
                    >
                        <path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" />
                        <path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" />
                    </svg>
                </div>

                <h4 className="font-semibold mb-4">Send Email</h4>
                <form onSubmit={handleSubmit}>
                    <p className="text-[12px] mt-2 bg-[#fdf8e3] text-[#8a6d3b] text-left rounded-sm py-2 pl-4 pr-6">
                        The selected Vehicle class is currently not available. Please leave your email address and phone number so we can contact you about alternatives.
                    </p>
                    <div className="flex flex-col md:flex-row md:space-x-4 mt-4">
                        <div className="flex-1 mb-4 md:mb-0">
                            <label className="block text-sm font-medium mb-1">Email Address</label>
                            <input type="text" className="w-full px-[8px] py-[8px] border rounded-md outline-none text-sm bg-transparent"
                                value={email}
                                onChange={handleChange}
                                onBlur={validateEmail}
                            />
                            {error && <span className="text-red-500 text-sm">{error}</span>}
                        </div>
                        <div className="flex-1">
                            <label className="block text-sm font-medium mb-1">Phone Number</label>
                            <PhoneNumberInput
                                name={"phoneNumber"}
                                value={phoneNumber}
                                setValue={setPhoneNumber}
                                fontSize={"14px"}
                                paddingBlock={"5px"}
                                required={true} />
                        </div>
                    </div>

                    {/* Buttons */}
                    <div className="flex gap-4 mt-6">
                        <button
                            type="submit"
                            className="text-white px-4 py-2 rounded cursor-pointer"
                            style={{
                                backgroundColor: webData?.websiteHeaderColor
                            }}
                        >
                            Send Email
                        </button>

                        <button
                            type="button"
                            onClick={closeModal}
                            className="px-4 py-2 rounded bg-gray-200 text-gray-800 hover:bg-gray-300 transition cursor-pointer"
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}